'use client'

import { createComponent } from '@lit/react'
import { type IPktBackLink as IPktElBackLink, PktBackLink as PktElBackLink } from '@oslokommune/punkt-elements'
// eslint-disable-next-line no-restricted-syntax -- React is required for createComponent
import React, { AnchorHTMLAttributes, ForwardRefExoticComponent, LegacyRef, MouseEventHandler } from 'react'

type ExtendedBackLink = Omit<IPktElBackLink, 'text'> & AnchorHTMLAttributes<HTMLAnchorElement>

export interface IPktBackLink extends ExtendedBackLink {
  text?: string
  ref?: LegacyRef<HTMLAnchorElement>
  ariaLabel?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

export const PktBackLink = createComponent({
  tagName: 'pkt-backlink',
  elementClass: PktElBackLink,
  react: React,
  displayName: 'PktBackLink',
}) as ForwardRefExoticComponent<IPktBackLink>

PktBackLink.displayName = 'PktBackLink'
